import { UPDATE_PROJECTS_QNQ_ENDPOINT } from '../../../../../../../common/config/api_endpoints';
import {
  createAPILifecycleActions,
  createAPILifecycleActionTypes,
} from '../../../../../../../redux/actions/action_utils';
import createAmplifyAPICallEpic from '../../../../../../../redux/epics/utils';
import { configureRefreshStateAction } from '../../../../../../../common/redux/configureRefreshState';
import { UPDATE_QNQ_DATA_REFRESH_DELAY_TIME_IN_MS } from '../../../../../../../common/components/table/constants';

export const UPDATE_PROJECTS_QNQ_ACTION_TYPES = createAPILifecycleActionTypes(
  'UPDATE_PROJECTS_QNQ_ACTION_TYPES',
);
export const updateProjectsQNQAction = createAPILifecycleActions(
  UPDATE_PROJECTS_QNQ_ACTION_TYPES.NAME,
);

const initialState = {
  isFetching: false,
  data: null,
  error: null,
};
export default (state = initialState, { type, payload }) => {
  switch (type) {
    case UPDATE_PROJECTS_QNQ_ACTION_TYPES.BEGIN:
      return {
        ...state,
        isFetching: true,
      };
    case UPDATE_PROJECTS_QNQ_ACTION_TYPES.SUCCESS:
      return {
        ...state,
        isFetching: false,
        data: {
          ...state.data,
          payload,
        },
        error: null,
      };
    case UPDATE_PROJECTS_QNQ_ACTION_TYPES.FAILURE:
      return {
        ...state,
        isFetching: false,
        data: null,
        error: payload,
      };

    case UPDATE_PROJECTS_QNQ_ACTION_TYPES.CLEAR:
      return initialState;
    default:
      return state;
  }
};

export const updateProjectsQNQEpic = createAmplifyAPICallEpic({
  actionType: UPDATE_PROJECTS_QNQ_ACTION_TYPES.BEGIN,
  api: UPDATE_PROJECTS_QNQ_ENDPOINT,
  successCallback: response => [
    updateProjectsQNQAction.SUCCESS(response),
    configureRefreshStateAction.BEGIN(UPDATE_QNQ_DATA_REFRESH_DELAY_TIME_IN_MS),
  ],
  errorCallback: () => [updateProjectsQNQAction.FAILURE()],
});
